import React, { useContext, useRef, useState } from 'react'
import { ContextApp, trackGameInteraction } from '@monorepo/service'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import { useTrackingEvents } from '../../hooks/useTrackingEvents'
import Header from '../Header'
import BonusComponent from '../BonusComponent'
import styles from '../../styles/styles.module.css'
import DecorateElements from '../DecorateElements'
import Modal from '../Modal'
import Wheel from '../Wheel'
import { GAME_CATEGORY, LANDING_TYPE } from '../../constants'

const Layout = () => {
  const { isCdaCheck } = useContext(ContextApp)
  const { geo } = useGeoRuntime()
  const [spinsCount, setSpinsCount] = useState(3)
  const [isOpenModal, setIsOpenModal] = useState(0)
  const [isAnimate, setIsAnimate] = useState(false)
  const attempt = useRef(0)

  useTrackingEvents(isCdaCheck)
  const handleSpin = () => {
    setIsAnimate(true)
    attempt.current += 1
    trackGameInteraction({
      landingType: LANDING_TYPE,
      gameCategory: GAME_CATEGORY,
      attempt: attempt.current
    })

    setTimeout(() => {
      setSpinsCount((prev) => {
        const next = prev - 1
        setIsOpenModal(next)
        return next
      })

      setIsAnimate(false)
    }, 4000)
  }

  const handleCloseModal = () => {
    setIsOpenModal(0)
  }

  return (
    <div className={styles.mainColumn} data-geo={geo}>
      <Header />
      <BonusComponent />
      <DecorateElements />
      <div className={styles.gameContainer}>
        <Wheel
          isAnimate={isAnimate}
          isOpenModal={isOpenModal}
          spinsCount={spinsCount}
          disabled={isAnimate || spinsCount < 1}
          onSpin={handleSpin}
        />
      </div>
      <Modal isOpenModal={isOpenModal} closeModal={handleCloseModal} />
    </div>
  )
}

export default Layout
